import React, { useState, useCallback } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Input,
  InputGroup,
  InputGroupText,
  Badge
} from "reactstrap";
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import SpinnerLoader from "components/Misc/Spinner";
import { getAllUsers, updateUser } from '../../actions/userActions'
import { connect } from 'react-redux';
import { errorToast, USER_STATUSES, successToast } from '../../shared/constants'
import { useHistory } from 'react-router-dom'
import Select2 from "react-select2-wrapper";
import toast, { Toaster } from "react-hot-toast";

function ManageUsers({getAllUsers, users, updateUser, deleteCategory}) {
  const [totalPages, setTotalPages] = useState(users?.totalPages)
  const [currentPage, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showSpinner, setSpinner] = useState(false);
  const [searchFocus, setSearchFocus] = useState(false)
  const [filter, setFilter] = useState('all')

  React.useEffect(() => {
    fetchUsers(
      {
        page: currentPage,
        status: filter,
        search: search
      }
    )
  }, []);

  const fetchUsers = async (body) => {
    setSpinner(true);
    getAllUsers(body.page, body.status, body.search)
    .then(data => {
      console.log(users)
      setPage(users.currentPage)
      setTotalPages(users.totalPages)
      setSpinner(false)
    })
    .catch(err => {
      console.log("Error: ", err)
    })
  }

  const pages = () => {
    let pagesArr = [];
    for (let i = 1; i <= users.totalPages; i++) {
      pagesArr.push(
        <PaginationItem className={users.currentPage === i ? "active" : ""}>
          <PaginationLink onClick={(e) => handlePageClick(e, i)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return pagesArr;
  };

  const handlePageClick = (e, pageNumber) => {
    e.preventDefault();
    fetchUsers({page: pageNumber, status: filter, search: search})
    setPage(pageNumber);
  };

  const handleSearch = (val) => {
    setSearch(val);
    fetchUsers({page: currentPage, status: filter, search: val})
  };

  const handleEditUser = async (e, id, isBlocked) => {
    await updateUser(id, {isBlocked})
    fetchUsers({page: currentPage, status: filter, search: search})
  }

  const handleFilterChange = useCallback(val => {
    setFilter(val)
    fetchUsers({page: currentPage, status: val, search: search})
  }, [filter])

  return (
    <>
      <SpinnerLoader showSpinner={showSpinner} />
      <SimpleHeader
        name="Manage Users"
        btn_name="Add New"
        updateList={() =>
          console.log("")
        }
      />
      <Container className="mt--4" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <div className="d-flex align-content-center justify-content-between">
                  <div className="search-field">
                    <InputGroup className="search-group">
                      <InputGroupText className={` search-icon`}>
                        <i className="fas fa-search fa-12x"></i>
                      </InputGroupText>
                      <Input
                        className="d-inline-block searchBox"
                        placeholder="Search..."
                        type="text"
                        value={search}
                        onFocus={() => setSearchFocus(true)}
                        onBlur={() => setSearchFocus(false)}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </InputGroup>
                    <InputGroup className="ml-3 filter">
                      <Select2
                        value={filter}
                        onSelect={(e) => handleFilterChange(e.params.data.id)}
                        data={[
                          {text: 'All', id: 'all'},
                          {text: 'Blocked', id: USER_STATUSES.blocked},
                          {text: 'Unblocked', id: USER_STATUSES.unblocked}
                        ]}
                        options= {{
                          minimumResultsForSearch: Infinity
                        }}
                      />
                      <i className="fas fa-chevron-down fa-12x filter-icon"></i>
                    </InputGroup>
                  </div>
                </div>
              </CardHeader>
              <div className="table-responsive">
                <Table className="dataTable align-items-center">
                  <thead className="thead-bh icon-color-light">
                    <tr>
                      <th className="px-5 w-10" scope="col">
                        Sr#
                      </th>
                      <th className="px-0 w-15" scope="col">
                        User Name
                      </th>
                      <th className="px-0 w-10" scope="col">
                        Email
                      </th>
                      <th className="px-0 w-10" scope="col">
                        Date of Birth
                      </th>
                      <th className="px-0 w-10" scope="col">
                        Status
                      </th>
                      <th className="px-0 w-5" scope="col">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="list">
                    {users?.users?.map((user, index) => (
                      <tr key={index}>
                        <td className="pl-5 ">
                          <div className="tbl-txt d-flex justify-content-start align-items-center">
                            {(users.currentPage*10)-(10-index-1)}
                          </div>
                        </td>
                        <td className="default-color overflowStyle pl-0 pr-4 tbl-txt cursor-pointer">
                          <div className="d-flex justify-content-start align-items-center">
                            <img src={user?.avatar ? user?.avatar : ''} className='tbl-img'/>
                            <span className="pl-2 tbl-txt">{user?.name}</span>
                          </div>
                        </td>
                        <td className="pl-0 pr-4 overflowStyle tbl-txt">
                          {user?.email}
                        </td>
                        <td className="pl-0 pr-4 overflowStyle tbl-txt">
                          {user?.dob ? user?.dob : '-'}
                        </td>
                        <td className={`pl-0 pr-4 overflowStyle tbl-txt ${user?.isBlocked ? 'text-danger' : 'text-success'}`}>
                          {user?.isBlocked ? 'Blocked' : 'Active'}
                        </td>
                        <td className="actionDropdown px-0">
                        <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn-icon-only text-light action-bg"
                              color=""
                              role="button"
                              size="sm"
                            >
                              <i className="fas fa-ellipsis-h action-dot" />
                            </DropdownToggle>
                            <DropdownMenu right className="mw-210">
                              <DropdownItem
                              onClick={(e) => handleEditUser(e, user._id, !(user?.isBlocked))}
                              >
                                <div className="d-flex align-items-center justify-content-start">
                                  <img src="/edit.svg" size='15px' alt="i"/>
                                  <div className="pl-2 action-txt">{user?.isBlocked ? 'UnBlock' : 'Block'}</div>
                                </div>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    ))}
                    <tr></tr>
                  </tbody>
                </Table>
                {!showSpinner && !users?.users?.length && (
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    No records found
                  </div>
                )}
              </div>
              <CardFooter className="py-4">
                <nav
                  className="d-flex align-items-center justify-content-between"
                  aria-label="..."
                >
                  <div className="pageEntry">
                  </div>
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem
                      className={users?.currentPage === 1 ? "disabled" : ""}
                    >
                      <PaginationLink
                        onClick={(e) => handlePageClick(e, users?.currentPage - 1)}
                        tabIndex="-1"
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    {pages().map((page, index) => (
                      <div key={index}>{page}</div>
                    ))}
                    <PaginationItem
                      className={
                        users.currentPage >= users.totalPages
                          ? "disabled"
                          : ""
                      }
                    >
                      <PaginationLink
                        onClick={(e) => handlePageClick(e, categories.currentPage + 1)}
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
      <Toaster/>
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    getAllUsers: (page, status, search ) => dispatch(getAllUsers(page, status, search)),
    updateUser: (id, body) => dispatch(updateUser(id, body)),
    deleteCategory: (id) => dispatch(deleteCategory(id))
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth,
      users: state.users
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
